"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var model_actions_types_1 = require("./model.actions.types");
function updateJson(payload) {
    return {
        type: model_actions_types_1.UPDATE_JSON,
        payload: payload
    };
}
exports.updateJson = updateJson;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kZWwuYWN0aW9ucy5jcmVhdG9ycy5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL3N0b3JlL21vZGVsLmFjdGlvbnMuY3JlYXRvcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw2REFBb0Q7QUFFcEQsU0FBZ0IsVUFBVSxDQUFDLE9BQU87SUFDaEMsT0FBTztRQUNILElBQUksRUFBRSxpQ0FBVztRQUNqQixPQUFPLFNBQUE7S0FDUixDQUFBO0FBQ0wsQ0FBQztBQUxELGdDQUtDIn0=